export const protipts_data = [
    {
        img: { url: 'img/protip1.png', width: '120px', height: '120px' },
        title: 'Pro Tip...',
        text: "Schedule your updates overnight and you will not disrupt anyone's work day.",
        subText: '- IDEXX team',
    }
];
